<template>
  <div :class="$style.singleSiteReportContainer">
    <div v-if="aggregateCriteriaConfiguration.length > 0">
      <Card
        :class="[
          $style.individualCriteriaContainer,
          individualMixedCriteriaConfiguration.length === 0
            ? $style.removeBottomMarginIndividualCriteriaContainer
            : null,
        ]"
        v-if="analysisFilter.checkIndividualCriteria && dataSet.length > 0"
      >
        <div
          v-for="(dataSetValue, dataSetIndex) in dataSet"
          :key="dataSetIndex"
        >
          <div
            :class="[
              $style.individualChartTitle,
              dataSetIndex !== 0 ? $style.applyMarginTitle : null,
            ]"
            v-if="loadingSet[dataSetIndex] ? loadingSet[dataSetIndex] : false"
          >
            <CriteriaViewUpdateComponent
              :criteria="criteriaList[dataSetIndex]"
              :count="dataSetIndex + 1"
              :isProject="true"
            />
          </div>
          <div v-if="analysisFilter.selectedChartType === 'Vertical Bar Chart'">
            <VerticalBarChart
              v-if="loadingSet[dataSetIndex] ? loadingSet[dataSetIndex] : false"
              :class="$style.individualChartVertical"
              :barChartData="dataSetValue"
              :barChartOptions="dataSetOptions[dataSetIndex]"
            ></VerticalBarChart>
          </div>
          <div v-else>
            <HorizontalBarChart
              v-if="loadingSet[dataSetIndex] ? loadingSet[dataSetIndex] : false"
              :class="$style.individualChartHorizontal"
              :barChartData="dataSetValue"
              :barChartOptions="dataSetOptions[dataSetIndex]"
            ></HorizontalBarChart>
          </div>
          <div :class="$style.individualCriteriaStatisticContainer">
            <h1 :class="$style.title">Table</h1>
            <div :class="$style.table">
              <SingleSiteTable
                :siteList="projectSitelist"
                :source="
                  individualBooleanCriteriaConfiguration[dataSetIndex]
                    .criteriaSamplingData
                "
                :sampleSize="
                  individualBooleanCriteriaConfiguration[dataSetIndex]
                    .sampleSize
                "
                :selectedPeriod="analysisFilter.selectedPeriod"
                :siteSamplingConfiguration="
                  individualBooleanCriteriaConfiguration[dataSetIndex]
                    .siteSamplingConfiguration
                "
                :samplingConfiguration="
                  individualBooleanCriteriaConfiguration[dataSetIndex]
                    .samplingConfiguration
                "
                :isAuditCriteria="
                  individualBooleanCriteriaConfiguration[dataSetIndex]
                    .isAuditCriteria
                "
                :criteriaSamplingDataConfiguration="
                  individualBooleanCriteriaConfiguration[dataSetIndex]
                    .criteriaSamplingDataConfiguration
                "
                :showComplianceRate="
                  individualBooleanCriteriaConfiguration[dataSetIndex]
                    .criteriaType === 'BOOLEAN'
                "
              />
            </div>
          </div>
        </div>
      </Card>
      <div
        :class="$style.verticalChartContainer"
        v-if="
          !analysisFilter.checkIndividualCriteria &&
          dataSet.length > 0 &&
          analysisFilter.selectedChartType === 'Vertical Bar Chart'
        "
      >
        <VerticalBarChart
          :class="$style.aggregateCriteriasVerticalBarChart"
          v-if="loadingSet[0] ? loadingSet[0] : false"
          :barChartData="dataSet[0]"
          :barChartOptions="dataSetOptions[0]"
        />
        <div v-if="analysisFilter.filteredCriterias.length > 8">
          <table :class="$style.criteriaListTable">
            <tr
              v-for="(
                projectCriteria, projectCriteriaIndex
              ) in getSelectedCriteriaList"
              :key="projectCriteriaIndex"
            >
              <td>{{ projectCriteriaIndex + 1 + '.' }}</td>
              <td>{{ projectCriteria.title }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div
        :class="$style.horizontalChartContainer"
        v-if="
          !analysisFilter.checkIndividualCriteria &&
          dataSet.length > 0 &&
          analysisFilter.selectedChartType === 'Horizontal Bar Chart'
        "
      >
        <HorizontalBarChart
          v-if="loadingSet[0] ? loadingSet[0] : false"
          :class="$style.aggregateCriteriasHorizontalBarChart"
          :barChartData="dataSet[0]"
          :barChartOptions="dataSetOptions[0]"
        ></HorizontalBarChart>
        <div v-if="analysisFilter.filteredCriterias.length > 8">
          <table :class="$style.criteriaListTable">
            <tr
              v-for="(
                projectCriteria, projectCriteriaIndex
              ) in getSelectedCriteriaList"
              :key="projectCriteriaIndex"
            >
              <td>{{ projectCriteriaIndex + 1 + '.' }}</td>
              <td>{{ projectCriteria.title }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div
        :class="$style.statisticContainer"
        v-if="renderOverallStatisticTable"
      >
        <div v-if="!analysisFilter.checkIndividualCriteria">
          <h1 :class="$style.title">Table</h1>
          <div
            v-for="(record, index) in aggregateCriteriaConfiguration"
            :key="`static${index}`"
            :class="$style.item"
          >
            <h2>
              <CriteriaViewUpdateComponent
                :criteria="record"
                :count="index + 1"
                :isProject="true"
              />
            </h2>
            <div :class="$style.table">
              <SingleSiteTable
                :siteList="projectSitelist"
                :source="record.criteriaSamplingData"
                :sampleSize="record.sampleSize"
                :selectedPeriod="analysisFilter.selectedPeriod"
                :siteSamplingConfiguration="record.siteSamplingConfiguration"
                :samplingConfiguration="record.samplingConfiguration"
                :isAuditCriteria="record.isAuditCriteria"
                :criteriaSamplingDataConfiguration="
                  record.criteriaSamplingDataConfiguration
                "
                :showComplianceRate="record.criteriaType === 'BOOLEAN'"
              />
            </div>
          </div>
        </div>
        <div v-else>
          <div
            v-for="(record, index) in individualMixedCriteriaConfiguration"
            :key="`static${index}`"
            :class="$style.mixedItem"
          >
            <h2>{{ getMixedBooleanTitleIndex(index) }}. {{ record.title }}</h2>
            <h1 :class="$style.mixedTitle">Table</h1>
            <div :class="$style.table">
              <SingleSiteTable
                :siteList="projectSitelist"
                :source="record.criteriaSamplingData"
                :sampleSize="record.sampleSize"
                :selectedPeriod="analysisFilter.selectedPeriod"
                :siteSamplingConfiguration="record.siteSamplingConfiguration"
                :samplingConfiguration="record.samplingConfiguration"
                :isAuditCriteria="record.isAuditCriteria"
                :criteriaSamplingDataConfiguration="
                  record.criteriaSamplingDataConfiguration
                "
                :showComplianceRate="record.criteriaType === 'BOOLEAN'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep as _cloneDeep, get as _get, map as _map } from 'lodash';
import Card from '@/components/Card.vue';
import SingleSiteTable from '@/components/reports/SingleSiteTable.vue';
import VerticalBarChart from '@/components/reports/VerticalBarChart';
import HorizontalBarChart from '@/components/reports/HorizontalBarChart';
import {
  ChartType,
  ChartRecords,
  ProjectSite,
  ProjectCriteria,
  ProjectReportFiltersConfig,
  ProjectReportSinglePeriodResponse,
} from '@/store/modules/projects/types/projects.types';
import { CRITERION_TYPE } from '@/store/types/criterions.types';
import {
  chartColorSet,
  primaryChartColor,
  labelSplitIndex,
} from '@/store/types/general.types';
import CriteriaViewUpdateComponent from './CriteriaViewUpdateComponent.vue';

@Component({
  components: {
    Card,
    SingleSiteTable,
    VerticalBarChart,
    HorizontalBarChart,
    CriteriaViewUpdateComponent,
  },
})
export default class SingleSiteReport extends Vue {
  @Prop()
  public analysisFilter!: ProjectReportFiltersConfig;
  @Prop()
  public projectSitelist!: ProjectSite[];
  @Prop()
  public projectCriteriaList!: ProjectCriteria[];
  @Prop()
  public reportResponse!: ProjectReportSinglePeriodResponse;

  public dataSet: any[] = [];
  public dataSetOptions: any[] = [];
  public loadingSet: boolean[] = [];
  public criteriaList: ProjectCriteria[] = [];
  public verticalBarChartDataSetOption: any = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 100,
            min: 0,
          },
          gridLines: {
            display: true,
          },
          scaleLabel: {
            labelString: 'Compliance %',
            display: true,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: true,
          },
          scaleLabel: {
            labelString: 'Criteria',
            display: false,
          },
          ticks: {
            minRotation: 0,
            callback: (label: string, index: number) => {
              return this.generateLabel(label, index);
            },
          },
        },
      ],
    },
    legend: {
      display: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          if (tooltipItem.yLabel < 0) {
            label += 'N/A';
          } else {
            label += Math.round(tooltipItem.yLabel * 100) / 100;
          }
          return label;
        },
      },
    },
  };
  public horizontalBarChartDataSetOption: any = {
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 100,
            min: 0,
          },
          gridLines: {
            display: true,
          },
          scaleLabel: {
            labelString: 'Compliance %',
            display: true,
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: true,
          },
          scaleLabel: {
            labelString: 'Criteria',
            display: false,
          },
          ticks: {
            minRotation: 0,
            callback: (label: string, index: number) => {
              return this.generateLabel(label, index);
            },
          },
        },
      ],
    },
    legend: {
      display: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          if (tooltipItem.xLabel < 0) {
            label += 'N/A';
          } else {
            label += Math.round(tooltipItem.xLabel * 100) / 100;
          }
          return label;
        },
      },
    },
  };
  public individualBooleanCriteriaConfiguration: any[] = [];
  public individualMixedCriteriaConfiguration: any[] = [];
  public aggregateCriteriaConfiguration: any[] = [];
  public renderOverallStatisticTable: boolean = true;

  public mounted() {
    this.populateData();
  }

  public populateData() {
    if (!this.reportResponse.success) {
      this.dataSet = [];
      this.dataSetOptions = [];
      this.loadingSet = [];
      this.individualBooleanCriteriaConfiguration = [];
      this.individualMixedCriteriaConfiguration = [];
    } else {
      this.dataSet = [];
      this.dataSetOptions = [];
      this.loadingSet = [];
      this.individualBooleanCriteriaConfiguration = [];
      this.individualMixedCriteriaConfiguration = [];
      const chartData: ChartRecords[] = this.reportResponse.chartData;
      this.generateConfigurationData(
        this.reportResponse.statisticData.configurationData,
        this.reportResponse.statisticData.samplingConfiguration,
      );
      if (chartData.length > 0) {
        this.singleSiteRender(chartData);
      }
    }
  }

  public singleSiteRender(chartData: ChartRecords[]) {
    const siteName = chartData[0].data[0].site.name;
    if (this.analysisFilter.checkIndividualCriteria) {
      this.renderIndividualCriteria(chartData, siteName);
    } else {
      this.renderAggregateCriteria(chartData, siteName);
    }
  }

  public renderIndividualCriteria(chartData: ChartRecords[], siteName: string) {
    Object.keys(chartData).forEach((key) => {
      const data = {
        labels: [] as string[],
        datasets: [] as any[],
      };
      let dataOptions = {};
      const dirtyChartData = chartData[Number(key)];
      const label = dirtyChartData.data[0].site.name;
      const chartValue = dirtyChartData.data[0].compliance;
      const dataSetObject = {
        label: dirtyChartData.criteria.title,
        backgroundColor: [primaryChartColor],
        hoverBackgroundColor: primaryChartColor,
        pointBackgroundColor: 'white',
        borderWidth: 1,
        pointBorderColor: '#249EBF',
        data: [chartValue],
        categoryPercentage: this.getIndividualCriteriaChartCategoryPercentage,
      };
      if (
        this.analysisFilter.selectedChartType === ChartType.verticalBarChart
      ) {
        dataOptions = _cloneDeep(this.verticalBarChartDataSetOption);
      } else {
        dataOptions = _cloneDeep(this.horizontalBarChartDataSetOption);
      }
      data.labels.push(label);
      data.datasets.push(dataSetObject);
      this.dataSet.push(data);
      this.dataSetOptions.push(dataOptions);
      this.loadingSet.push(true);
      this.criteriaList.push(dirtyChartData.criteria);
    });
  }

  public renderAggregateCriteria(chartData: ChartRecords[], siteName: string) {
    const data = {
      labels: [] as string[],
      datasets: [] as any[],
    };
    let dataOptions = {};
    const labels: string[] = [];
    const chartValues: number[] = [];
    const backgroundColors: string[] = [];
    Object.keys(chartData).map((key: string) => {
      labels.push(chartData[Number(key)].criteria.title);
      chartValues.push(chartData[Number(key)].data[0].compliance);
      backgroundColors.push(primaryChartColor);
    });
    const dataSetObject = {
      label: siteName,
      backgroundColor: backgroundColors,
      hoverBackgroundColor: primaryChartColor,
      pointBackgroundColor: 'white',
      borderWidth: 1,
      pointBorderColor: '#249EBF',
      data: chartValues,
      categoryPercentage: this.getAggregateCriteriaChartCategoryPercentage,
    };
    let dataOptionsObject;
    if (this.analysisFilter.selectedChartType === ChartType.verticalBarChart) {
      dataOptionsObject = _cloneDeep(this.verticalBarChartDataSetOption);
    } else {
      dataOptionsObject = _cloneDeep(this.horizontalBarChartDataSetOption);
    }
    data.labels = _cloneDeep(labels);
    data.datasets = [];
    data.datasets.push(dataSetObject);
    dataOptions = _cloneDeep(dataOptionsObject);
    this.dataSet.push(data);
    this.dataSetOptions.push(dataOptions);
    this.loadingSet.push(true);
  }

  public generateConfigurationData(
    configurationData: any[],
    samplingConfiguration: any,
  ) {
    if (Array.isArray(configurationData) && configurationData.length > 0) {
      const aggregateConfig: any = configurationData.map((data: any) => {
        const criteriaOptionsDataDistribution =
          data.criteriaSamplingData.criteriaOptionsDataDistribution;
        const criteriaSamplingData = Object.keys(
          criteriaOptionsDataDistribution,
        ).map((key: string) => ({
          [key]: data.criteriaSamplingData.criteriaOptionsDataDistribution[key],
        }));
        return {
          id: data.projectCriteria.id,
          title: _get(data, 'projectCriteria.title', ''),
          criteriaType: _get(data, 'projectCriteria.criteriaType', ''),
          sampleSize: Number(
            _get(data, 'criteriaSamplingDataConfigurations.sampleSize', 0),
          ),
          criteriaOptions: JSON.parse(data.projectCriteria.criteriaOptions),
          siteSamplingConfiguration: data.siteSamplingDataConfigurations,
          criteriaSamplingDataConfiguration:
            data.criteriaSamplingDataConfigurations,
          samplingConfiguration,
          criteriaSamplingData,
          isAuditCriteria: _get(data, 'isAuditCriteria', false),
        };
      });
      this.aggregateCriteriaConfiguration = _cloneDeep(aggregateConfig);
    } else {
      this.aggregateCriteriaConfiguration = [];
    }
    this.generateIndividualCriteriaSet(this.aggregateCriteriaConfiguration);
  }

  public generateIndividualCriteriaSet(aggregateCriteriaConfiguration: any[]) {
    this.individualBooleanCriteriaConfiguration = aggregateCriteriaConfiguration.filter(
      (item) => {
        return item.criteriaType === CRITERION_TYPE.BOOLEAN;
      },
    );
    this.individualMixedCriteriaConfiguration = aggregateCriteriaConfiguration.filter(
      (item) => {
        return item.criteriaType !== CRITERION_TYPE.BOOLEAN;
      },
    );
    if (
      this.individualBooleanCriteriaConfiguration.length ===
        this.aggregateCriteriaConfiguration.length &&
      this.analysisFilter.checkIndividualCriteria
    ) {
      this.renderOverallStatisticTable = false;
    }
  }

  public getMixedBooleanTitleIndex(index: number) {
    return this.individualBooleanCriteriaConfiguration.length + index + 1;
  }

  public generateLabel(label: string, index: number): string | string[] {
    if (this.analysisFilter.checkIndividualCriteria) {
      return this.transformLabel(label);
    } else {
      if (this.analysisFilter.filteredCriterias.length > 8) {
        return index + 1 + '.';
      }
      return this.transformLabel(label);
    }
  }

  public transformLabel(label: string): string | string[] {
    const words = label.split(' ');
    let endIndex: number = labelSplitIndex;
    let eachLine: string = '';
    const eachLabel: string[] = [];
    _map(words, (word: string, wordIndex: string) => {
      switch (Number(wordIndex)) {
        case 0:
          eachLine = word;
          break;
        case endIndex:
          eachLabel.push(eachLine);
          eachLine = word;
          endIndex += labelSplitIndex;
          break;
        case words.length - 1:
          eachLine += ' ' + word;
          eachLabel.push(eachLine);
          break;
        default:
          eachLine += ' ' + word;
      }
    });
    if (eachLabel.length >= 3) {
      eachLabel[2] = eachLabel[2] + '...';
      return eachLabel.slice(0, 3);
    }
    return label;
  }

  get getAggregateCriteriaChartCategoryPercentage() {
    const noOfBooleanCriterias: number = this
      .individualBooleanCriteriaConfiguration.length;
    return noOfBooleanCriterias <= 10 ? noOfBooleanCriterias * 0.1 : 0.8;
  }

  get getIndividualCriteriaChartCategoryPercentage() {
    if (this.analysisFilter.selectedChartType === ChartType.verticalBarChart) {
      return 0.1;
    } else {
      return 0.2;
    }
  }

  get getSelectedCriteriaList(): ProjectCriteria[] {
    const selectedCriteriaList: any[] = [];
    this.analysisFilter.filteredCriterias.forEach(
      (projectCriteriaMapId: number) => {
        const projectCriteria = this.projectCriteriaList.find((criteria) => {
          return (
            criteria.id === projectCriteriaMapId &&
            criteria.criteriaType === CRITERION_TYPE.BOOLEAN
          );
        });
        if (projectCriteria) {
          selectedCriteriaList.push(projectCriteria);
        }
      },
    );
    return selectedCriteriaList;
  }
}
</script>
<style lang="scss" module>
.verticalChartContainer,
.horizontalChartContainer {
  width: auto;
  height: auto;
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 40px;
}
.individualCriteriaContainer {
  display: flex;
  flex-direction: column;
  padding: unset;
  background-color: unset;
  border: unset;
  margin-bottom: 40px;
  box-shadow: unset;
}
.removeBottomMarginIndividualCriteriaContainer {
  margin-bottom: unset;
}
.individualChartTitle {
  color: #444f51;
  font-size: 16px;
  padding-left: 24px;
  padding-right: 24px;
}
.statisticContainer {
  padding: 24px 24px 40px 24px;
  flex-direction: column;
  background-color: #fbfbfb;
  border: 1px solid #dfdfdf;
  .title {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
    color: #444f51;
  }
  .item {
    padding: 20px 0px 40px 0px;
    border-bottom: 1px solid $grey-2;
    .table {
      padding: 20px 0px 0px 20px;
    }
  }
  .item:last-child {
    padding-bottom: unset;
    border-bottom: unset;
  }
  .mixedItem {
    padding: 20px 0px 40px 0px;
    border-bottom: 1px solid $grey-2;
    &:first-child {
      padding-top: 0px;
    }
    .table {
      padding: 20px 0px 0px 0px;
    }
    .mixedTitle {
      margin-top: 24px;
      font-size: 14px;
      font-weight: bold;
      color: #444f51;
      text-transform: uppercase;
    }
  }
  .mixedItem:last-child {
    padding-bottom: unset;
    border-bottom: unset;
  }
}
.singleSiteReportContainer {
  width: 100%;
}
.individualChartVertical {
  padding: 24px 24px 0px 24px;
  margin-bottom: 24px;
  width: auto;
  height: auto;
  div {
    width: auto;
  }
  canvas {
    width: auto !important;
  }
}
.individualChartHorizontal {
  padding: 24px 24px 0px 24px;
  margin-bottom: 24px;
  width: auto;
  height: auto;
  div {
    width: auto;
  }
  canvas {
    width: auto !important;
  }
}
.individualCriteriaStatisticContainer {
  padding: 24px 24px 40px 24px;
  flex-direction: column;
  background-color: #fbfbfb;
  border: 1px solid #dfdfdf;
  .title {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
    color: #444f51;
  }
  .table {
    margin-top: 18px;
  }
  .item {
    padding: 20px 0;
    border-bottom: 1px solid $grey-2;
    .table {
      padding: 20px 0px 0px 20px;
    }
  }
  .item:last-child {
    padding-bottom: unset;
    border-bottom: unset;
  }
}
.applyMarginTitle {
  margin-top: 60px;
}
.aggregateCriteriasHorizontalBarChart {
  height: 800px;
  width: auto;
  margin-top: unset;
  div {
    width: auto;
  }
  canvas {
    width: auto !important;
  }
}
.aggregateCriteriasVerticalBarChart {
  height: auto;
  margin-top: unset;
  div {
    width: auto;
  }
  canvas {
    width: auto !important;
  }
}
.criteriaListTable {
  background: #eff7ff;
  width: 100%;
  margin-top: 20px;
  font-size: 12px;
  tr {
    td:first-child {
      text-align: right;
      width: 30px;
    }
    td:nth-child(2) {
      padding-left: 4px;
    }
  }
  td {
    padding-top: 2px;
    padding-bottom: 2px;
  }
  tr:first-child {
    td {
      padding-top: 12px;
    }
  }
  tr:last-child {
    td {
      padding-bottom: 12px;
    }
  }
}
</style>
